












import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import {Icon} from "@/helpers/icons";
import AsiToolbar from "../common/AsiToolbar.vue";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import AsiCard from "@/components/common/AsiCard.vue";
import PlanningEntryCard from "@/components/planningEntry/PlanningEntryCard.vue";
import PlanningEntryListEntry from "@/models/planningEntry/PlanningEntryListEntry";
import AsiListTableOptions from "@/components/common/AsiListTableOptions";
import PlanningEntryListFilter from "@/models/planningEntry/PlanningEntryListFilter";
import {toISODateString} from "@/helpers/functions_asi";
import {SnackbarMessage} from "@/models/SnackbarMessage";

@Component({
	components: {PlanningEntryCard, AsiCard, AsiContentContainer, AsiToolbar}
})
export default class DriversPendingReports extends Vue {

	@Prop({type: String, required: true})
	public userId!: string | null;

	private planningEntries: PlanningEntryListEntry[] = [];
	private icons = Icon;
	private loading: boolean = false;

	public created(): void {
		this.fetchData();
	}

	@Emit('reportCreated')
	public reportCreated(): void {
		this.fetchData();
	}

	private fetchData(): void {
		if (this.userId === null) return;

		const tableOptions: AsiListTableOptions = new AsiListTableOptions();
		tableOptions.sortBy = ['date'];
		tableOptions.sortDesc = [false];

		const filter = new PlanningEntryListFilter();
		filter.dateTo = toISODateString(new Date());
		filter.hasReports = false;

		this.loading = true;
		this.$userService.planningEntries(this.userId, filter, tableOptions)
			.then(res => {
				this.planningEntries = res.data;
			})
			.catch(() => {
				this.$store.commit('ui/showSnackbar', {
					message: this.$t('snackbar.loadingError'),
					color: 'error',
				} as SnackbarMessage);
			})
			.finally(() => this.loading = false);
	}

}
